import { Wrapper, Text } from './Styled'

export default function Currency({ product_coin }) {
  return (
    <Wrapper>
      <Text>{product_coin}</Text>
    </Wrapper>
  )
}
